import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import React from "react";
import { InvoiceTagValue } from "./util";

export const INVOICE_TAG_OPTIONS: { value: InvoiceTagValue; label: string }[] = [
  { value: "invoiced", label: "Invoiced" },
  { value: "pending_billing", label: "Pending Billing" },
  { value: "pending_po", label: "Pending PO" },
  { value: "credit_hold", label: "Credit Hold" },
  { value: "others", label: "Others" },
];

interface Props {
  value: InvoiceTagValue;
  onChange: (value: InvoiceTagValue) => void;
}

const InvoiceTagRadioGroup: React.FC<Props> = ({ value, onChange }) => (
  <FormControl component="fieldset" fullWidth style={{ marginTop: 8, marginBottom: 18 }}>
    <FormLabel component="legend">
      <Typography
        variant="subtitle1"
        gutterBottom
        color="textSecondary"
        style={{ marginBottom: 2 }}
      >
        Invoice Tag
      </Typography>
    </FormLabel>
    <RadioGroup
      name="pending-status"
      value={value}
      onChange={(event) => onChange(event.target.value as InvoiceTagValue)}
    >
      {INVOICE_TAG_OPTIONS.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<Radio size={"small"} style={{ paddingTop: 4, paddingBottom: 4 }} />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  </FormControl>
);

export default InvoiceTagRadioGroup;
